import React, { useState } from "react";

import { Map, MapMarker } from "react-kakao-maps-sdk";

import { supabaseServiceRole } from "../supabase/config/supabase.config";

import { BasicAlert } from "components/Alert";

const EmailForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");

  const sendMessage = async () => {
    if (name !== "" && email !== "" && content !== "") {
      const { error } = await supabaseServiceRole
        .from("enkino_homepage_inquiry")
        .insert([{ name, email, content }]);

      if (error) {
        BasicAlert("오류가 발생했습니다.");
        console.error(error);
      } else {
        BasicAlert("문의가 접수되었습니다.");
        setName("");
        setEmail("");
        setContent("");
      }
    } else {
      BasicAlert("이름, 이메일, 문의 내용을 입력해 주세요.");
    }
  };

  return (
    <form className="">
      <div className="w-full mb-3">
        <h2 className="mx-auto w-full text-center text-xl mb-2 font-bold">
          문의사항
        </h2>
        <label
          className="block uppercase text-gray-900 text-sm font-bold mb-2"
          htmlFor="input_name"
        >
          이름
        </label>
        <input
          id="input_name"
          type="text"
          className="px-3 py-3 placeholder-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
          placeholder="이름"
          value={name}
          onChange={({ target: { value } }) => setName(value)}
          style={{ transition: "all 0.15s ease 0s" }}
        />
      </div>
      <div className="relative w-full mb-3">
        <label
          className="block uppercase text-gray-900 text-sm font-bold mb-2"
          htmlFor="input_email"
        >
          이메일
        </label>
        <input
          id="input_email"
          type="email"
          className="px-3 py-3 placeholder-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
          placeholder="이메일"
          value={email}
          onChange={({ target: { value } }) => setEmail(value)}
          style={{ transition: "all 0.15s ease 0s" }}
        />
      </div>
      <div className="relative w-full mb-3">
        <label
          className="block uppercase text-gray-900 text-sm font-bold mb-2"
          htmlFor="input_message"
        >
          내용
        </label>
        <textarea
          id="input_message"
          type="text"
          className="px-3 py-3 placeholder-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
          placeholder="내용"
          value={content}
          onChange={({ target: { value } }) => setContent(value)}
          style={{ transition: "all 0.15s ease 0s" }}
        />
      </div>
      <div className="text-center mt-6">
        <button
          className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full"
          type="button"
          style={{ transition: "all 0.15s ease 0s" }}
          onClick={sendMessage}
        >
          문의 보내기
        </button>
      </div>
    </form>
  );
};

const Information = ({ doc }) => {
  const { tel, email, addr1, addr2, lat, lng } = doc;
  // const mapStyle = settings.isMobile ? { width: "100vw", height: "450px" } : { width: "100%", height: "450px" };
  // const mapStyle =  {width: "100%", height: "450px" };

  return (
    <div id="information" className="w-full">
      <h2 className="text-3xl tracking-tight font-extrabold text-white sm:text-5xl py-12 center">
        오시는 길
      </h2>
      <div className="w-full">
        <div className="flex-row-center">
          <div className="w-full lg:w-1/3">
            <div className="mt-4 lg:mt-0 flex items-center justify-start lg:justify-center">
              <div className="rounded-full w-10 h-10 md:w-16 md:h-16 center border border-white">
                <i className="fas fa-phone-alt fa-1x md:fa-2x text-white" />
              </div>
              <div className="pl-6 text-white font-bold">
                <p className="text-lg">Phone</p>
                <p className="mt-1.5 text-base">{tel}</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/3">
            <div className="mt-4 lg:mt-0 flex items-center justify-start lg:justify-center">
              <div className="rounded-full  w-10 h-10 md:w-16 md:h-16  center border border-white">
                <i className="far fa-envelope fa-1x md:fa-2x text-white" />
              </div>
              <div className="pl-6 text-white font-bold">
                <p className="text-lg">Email</p>
                <p className="mt-1.5 text-base">{email}</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/3">
            <div className="mt-4 lg:mt-0 flex items-center justify-start lg:justify-center">
              <div className="rounded-full  w-10 h-10 md:w-16 md:h-16  center border border-white">
                <i className="fas fa-map-marker-alt fa-1x md:fa-2x text-white" />
              </div>
              <div className="pl-6 text-white font-bold">
                <p className="text-lg">Address</p>
                <p className="mt-1.5 text-base keep-words">
                  {addr1}
                  <br />
                  {addr2}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-20 md:mb-10 w-full glass_box">
          <div className="flex-col-center md:flex md:flex-row items-center justify-center ">
            <div className="w-full md:w-3/5 md:pl-0">
              <Map
                center={{ lat, lng }}
                style={{ width: "100%", height: "450px" }}
              >
                <MapMarker position={{ lat, lng }}></MapMarker>
              </Map>
            </div>
            <div className="w-full md:pb-0 md:w-2/5 pl-0 md:pl-8 mt-16 md:mt-0">
              <EmailForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CompanyMap = () => {
  const myDoc = {
    tel: "070-8813-6229",
    email: "cs@enkino.com",
    addr1: "경기 안양시 동안구 시민대로 187",
    addr2: "안양 건설타워 1006호",
    lat: 37.391758,
    lng: 126.9517626,
  };

  return (
    <section className="section4 w-full h-full">
      <div className="mx-auto max-w-7xl mt-32">
        <div className="glass_box px-2">
          <Information doc={myDoc} />
        </div>
      </div>
    </section>
  );
};

export default CompanyMap;
